export const isTextValid = (text) => /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/.test(text);
export const isUsernameValid = (text) => /^[a-zA-Z0-9]*$/.test(text);
export const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const isPasswordValid = (password) => password.length >= 7;